import { render, staticRenderFns } from "./v-accordion-group.vue?vue&type=template&id=5d40b253&scoped=true&"
var script = {}
import style0 from "./v-accordion-group.vue?vue&type=style&index=0&id=5d40b253&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40b253",
  null
  
)

export default component.exports